import { Box, HStack, Header } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

export const Group = Box.withConfig({
  backgroundColor: getDesignToken('background-card'),
  marginBottom: '$2',
});

export const HeaderWrapper = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: 6,
  paddingBottom: 2,
  paddingX: 4,
});

export const HeaderText = Header.withConfig<{ $isNested?: boolean }>(({ $isNested }) => ({
  variant: $isNested ? 'headerFour' : 'headerThree',
  margin: 0,
  // Variants `headerThree`/`headerFour` bake in `mb: 3` (= 12dp). The `margin: 0` shorthand
  // above doesn't always win against the more-specific variant `marginBottom`, so set it
  // explicitly to keep the heading tight against its container.
  marginBottom: 0,
  flex: 1,
  paddingRight: '$2',
}));

export const SubHeaderText = withTypography({
  variant: 'copyTwo',
  px: '$1',
  style: { paddingVertical: 1, marginTop: -2, marginBottom: 0 },
});

export const Footer = HStack.withConfig({
  borderBottomWidth: '1px',
  borderBottomColor: '#dcdcdc',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 10,
  paddingX: 4,
  paddingY: 1,
});
